export default __webpack_public_path__ + "static/media/MoneyMatters.a54ec1d1.png";